import React from 'react';

import classnames from 'classnames';

import Section from '../Section';
import Banner from '../Banner';

import styles from './BannerCustom.module.scss';

import componentsId from '../../utils/componentsId';

type BannerT = {
  img: string;
  callToAction?: {
    id: string;
    text: string;
    onClick: () => void;
    icon?: string;
    iconFirst?: boolean;
  };
  title?: string;
  description?: string;
  id: string;
  className?: string;
};

const BannerCustom = ({
  img,
  callToAction,
  title = '',
  description = '',
  id,
  className,
}: BannerT) => {
  const bannerClass = classnames(styles.banner_card, {
    [`${className}`]: className,
  });

  return (
    <Section id={componentsId.landingBannerSection} customClass={styles.banner}>
      <Banner
        id={id}
        title={title}
        description={description}
        img={img}
        callToAction={callToAction}
        theme="primary"
        className={bannerClass}
      />
    </Section>
  );
};

export default BannerCustom;
